import Dashboard from "../pages/Dashboard/Dashboard";
import {
  LayoutGrid,
  Calendar,
  ClipboardMinus,
  FileSignature,
  User,
  FileText,
  BarChart2,
  Users,
  ShieldCheck,
  Package,
  Settings,
  Car,
  Clock,
  CalendarOff,
  ShoppingCart,
  Trophy,
  FolderOpen,
  Radio,
  Scale,
  Crown,
  Wrench,
  MapPin,
  ShieldAlert,
  FlaskConical,
  MessageSquare,
  Receipt,
  FileCheck,
  Bell,
  Building2,
  Bot,
  Repeat,
} from "lucide-react";
import SettingsPage from "../pages/settings/SettingsPage";
import SuperAdminPage from "../pages/superAdmin/SuperAdminPage";
import CompliancePage from "../pages/compliance/CompliancePage";
import InventoryPage from "../pages/inventory/InventoryPage";
import SchedulePage from "../pages/schedule/SchedulePage";
import JobsPage from "../pages/jobs/JobsPage";
import ClientsPage from "../pages/clients/ClientsPage";
import InvoicesPage from "../pages/invoices/InvoicesPage";
import ReportsPage from "../pages/reports/ReportsPage";
import FieldWorkersPage from "../pages/fieldWorkers/FieldWorkersPage";
import QuotesPage from "../pages/quotes/QuotesPage";
import ContractsPage from "../pages/contracts/ContractsPage";
import TimesheetsPage from "../pages/timesheets/TimesheetsPage";
import FleetPage from "../pages/fleet/FleetPage";
import PurchaseOrdersPage from "../pages/purchaseOrders/PurchaseOrdersPage";
import LeaveRequestsPage from "../pages/leaveRequests/LeaveRequestsPage";
import LoneWorkerPage from "../pages/loneWorker/LoneWorkerPage";
import EmployeeLocationsPage from "../pages/employeeLocations/EmployeeLocationsPage";
import TendersPage from "../pages/tenders/TendersPage";
import DocumentsPage from "../pages/documents/DocumentsPage";
import JobConfigPage from "../pages/job-config/JobConfigPage";
import StaffPage from "../pages/staff/StaffPage";
import LedgerPage from "../pages/ledger/LedgerPage";
import IncidentReportsPage from "../pages/incidents/IncidentReportsPage";
import CoshhPage from "../pages/coshh/CoshhPage";
import MessagingPage from "../pages/messages/MessagingPage";
import WorkerQuotesPage from "../pages/workerQuotes/WorkerQuotesPage";
import PayslipsPage from "../pages/payslips/PayslipsPage";
import NotificationsPage from "../pages/notifications/NotificationsPage";
import AssetsPage from "../pages/assets/AssetsPage";
import CISPage from "../pages/payroll/CISPage";
import NMWPage from "../pages/payroll/NMWPage";
import PensionPage from "../pages/payroll/PensionPage";
import AIAgentPage from "../pages/ai-agent/AIAgentPage";
import UsersPage from "../pages/users/UsersPage";
import CommsHubPage from "../pages/commsHub/CommsHubPage";
import RecurringSchedulesPage from "../pages/recurringSchedules/RecurringSchedulesPage";

export interface AppRoute {
  key: string;
  label: string;
  url?: string;
  icon?: React.ComponentType<any>;
  component?: React.ComponentType;
  children?: AppRoute[];
  hidden?: boolean;
  ignore?: number;
  type?: string;
  count?: number;
  badgeColor?: string;
  permission?: {
  module: string;
  action: string;
}
}

const routes: AppRoute[] = [
  // ─── OPERATIONS ────────────────────────────────────────────────────────────
  {
    key: "1",
    label: "Dashboard",
    url: "/",
    icon: LayoutGrid,
    component: Dashboard,
    type: "OPERATIONS",
    permission: { module: "dashboard", action: "view" },
  },
  {
    key: "2",
    label: "Schedule",
    url: "/schedule",
    icon: Calendar,
    component: SchedulePage,
    type: "OPERATIONS",
    permission: { module: "schedule", action: "view" },
  },
  {
    key: "3",
    label: "Jobs",
    url: "/jobs",
    icon: ClipboardMinus,
    component: JobsPage,
    type: "OPERATIONS",
    permission: { module: "jobs", action: "view" },
  },
  {
    key: "4",
    label: "Quotes",
    url: "/quotes",
    icon: FileSignature,
    component: QuotesPage,
    type: "OPERATIONS",
    permission: { module: "quotes", action: "view" },
  },
  {
    key: "4b",
    label: "Recurring Schedules",
    url: "/recurring-schedules",
    icon: Repeat,
    component: RecurringSchedulesPage,
    type: "OPERATIONS",
    permission: { module: "jobs", action: "view" },
  },

  // ─── CLIENTS ───────────────────────────────────────────────────────────────
  {
    key: "5",
    label: "Clients",
    url: "/clients",
    icon: User,
    component: ClientsPage,
    type: "CLIENTS",
    permission: { module: "clients", action: "view" },
  },
  {
    key: "6",
    label: "Contracts",
    url: "/contracts",
    icon: FileText,
    component: ContractsPage,
    type: "CLIENTS",
    permission: { module: "contracts", action: "view" },
  },
  {
    key: "7",
    label: "Tenders",
    url: "/tenders",
    icon: Trophy,
    component: TendersPage,
    type: "CLIENTS",
    permission: { module: "tenders", action: "view" },
  },

  // ─── FINANCE ───────────────────────────────────────────────────────────────
  {
    key: "8",
    label: "Invoices",
    url: "/invoices",
    icon: FileText,
    component: InvoicesPage,
    type: "FINANCE",
    permission: { module: "invoices", action: "view" },
  },
  {
    key: "9",
    label: "Purchase Orders",
    url: "/purchase-orders",
    icon: ShoppingCart,
    component: PurchaseOrdersPage,
    type: "FINANCE",
    permission: { module: "purchase_orders", action: "view" },
  },
  {
    key: "10",
    label: "Reports",
    url: "/reports",
    icon: BarChart2,
    component: ReportsPage,
    type: "FINANCE",
    permission: { module: "reports", action: "view" },
  },
  {
    key: "10b",
    label: "Ledger",
    url: "/ledger",
    icon: BarChart2,
    component: LedgerPage,
    type: "FINANCE",
    permission: { module: "invoices", action: "view" },
  },

  // ─── WORKFORCE ─────────────────────────────────────────────────────────────
  {
    key: "11",
    label: "Field Workers",
    url: "/field-workers",
    icon: Users,
    component: FieldWorkersPage,
    type: "WORKFORCE",
    permission: { module: "field_workers", action: "view" },
  },
  {
    key: "11b",
    label: "Staff Management",
    url: "/staff",
    icon: Users,
    component: StaffPage,
    type: "WORKFORCE",
    permission: { module: "users", action: "view" },
  },
  {
    key: "11c",
    label: "Team Members",
    url: "/users",
    icon: Users,
    component: UsersPage,
    type: "WORKFORCE",
    permission: { module: "users", action: "view" },
  },
  {
    key: "12",
    label: "Timesheets",
    url: "/timesheets",
    icon: Clock,
    component: TimesheetsPage,
    type: "WORKFORCE",
    permission: { module: "timesheets", action: "view" },
  },
  {
    key: "13",
    label: "Leave",
    url: "/leave",
    icon: CalendarOff,
    component: LeaveRequestsPage,
    type: "WORKFORCE",
    permission: { module: "leave", action: "view" },
  },
  {
    key: "14",
    label: "Fleet",
    url: "/fleet",
    icon: Car,
    component: FleetPage,
    type: "WORKFORCE",
    permission: { module: "fleet", action: "view" },
  },
  {
    key: "15",
    label: "Lone Worker",
    url: "/lone-worker",
    icon: Radio,
    component: LoneWorkerPage,
    type: "WORKFORCE",
    permission: { module: "lone_workers", action: "view" },
  },
  {
    key: "15b",
    label: "Live Locations",
    url: "/employee-locations",
    icon: MapPin,
    component: EmployeeLocationsPage,
    type: "WORKFORCE",
    permission: { module: "employee_locations", action: "view" },
  },

  // ─── SAFETY & COMPLIANCE ───────────────────────────────────────────────────
  {
    key: "16",
    label: "Compliance",
    url: "/compliance",
    icon: ShieldCheck,
    component: CompliancePage,
    type: "SAFETY",
    permission: { module: "compliance", action: "view" },
  },
  {
    key: "16b",
    label: "Incident Reports",
    url: "/incidents",
    icon: ShieldAlert,
    component: IncidentReportsPage,
    type: "SAFETY",
    permission: { module: "compliance", action: "view" },
  },
  {
    key: "16c",
    label: "COSHH Substances",
    url: "/coshh",
    icon: FlaskConical,
    component: CoshhPage,
    type: "SAFETY",
    permission: { module: "compliance", action: "view" },
  },

  // ─── ASSETS ────────────────────────────────────────────────────────────────
  {
    key: "17",
    label: "Inventory",
    url: "/inventory",
    icon: Package,
    component: InventoryPage,
    type: "ASSETS",
    permission: { module: "inventory", action: "view" },
  },
  {
    key: "18",
    label: "Documents",
    url: "/documents",
    icon: FolderOpen,
    component: DocumentsPage,
    type: "ASSETS",
    permission: { module: "documents", action: "view" },
  },
  {
    key: "18b",
    label: "Job Config",
    url: "/job-config",
    icon: Wrench,
    component: JobConfigPage,
    type: "ASSETS",
    permission: { module: "job_config", action: "view" },
  },
  {
    key: "18c",
    label: "Assets",
    url: "/assets",
    icon: Wrench,
    component: AssetsPage,
    type: "ASSETS",
    permission: { module: "inventory", action: "view" },
  },

  // ─── WORKFORCE additions ───────────────────────────────────────────────────
  {
    key: "15c",
    label: "Messages",
    url: "/messages",
    icon: MessageSquare,
    component: MessagingPage,
    type: "WORKFORCE",
    permission: { module: "field_workers", action: "view" },
  },
  {
    key: "15d",
    label: "Payslips",
    url: "/payslips",
    icon: Receipt,
    component: PayslipsPage,
    type: "WORKFORCE",
    permission: { module: "timesheets", action: "view" },
  },

  // ─── OPERATIONS additions ─────────────────────────────────────────────────
  {
    key: "3b",
    label: "Worker Quotes",
    url: "/worker-quotes",
    icon: FileCheck,
    component: WorkerQuotesPage,
    type: "OPERATIONS",
    permission: { module: "quotes", action: "view" },
  },
  {
    key: "3c",
    label: "Notifications",
    url: "/notifications",
    icon: Bell,
    component: NotificationsPage,
    type: "OPERATIONS",
    permission: { module: "dashboard", action: "view" },
  },

  // ─── PAYROLL ──────────────────────────────────────────────────────────────
  {
    key: "15e",
    label: "CIS Returns",
    url: "/cis",
    icon: FileText,
    component: CISPage,
    type: "WORKFORCE",
    permission: { module: "timesheets", action: "view" },
  },
  {
    key: "15f",
    label: "NMW Compliance",
    url: "/nmw",
    icon: ShieldCheck,
    component: NMWPage,
    type: "WORKFORCE",
    permission: { module: "timesheets", action: "view" },
  },
  {
    key: "15g",
    label: "Pension",
    url: "/pension",
    icon: Building2,
    component: PensionPage,
    type: "WORKFORCE",
    permission: { module: "timesheets", action: "view" },
  },

  // ─── COMMS HUB ────────────────────────────────────────────────────────────
  {
    key: "21",
    label: "Comms Hub",
    url: "/comms-hub",
    icon: MessageSquare,
    component: CommsHubPage,
    type: "OPERATIONS",
    permission: { module: "dashboard", action: "view" },
  },

  // ─── AI ASSISTANT ──────────────────────────────────────────────────────────
  {
    key: "20",
    label: "AI Assistant",
    url: "/ai-agent",
    icon: Bot,
    component: AIAgentPage,
    type: "PLATFORM",
    permission: { module: "dashboard", action: "view" },
  },

  // ─── PLATFORM ──────────────────────────────────────────────────────────────
  {
    key: "19",
    label: "Settings",
    url: "/settings",
    icon: Settings,
    component: SettingsPage,
    type: "PLATFORM",
    permission: { module: "settings", action: "view" },
  },
];

export default routes;
